import {combineReducers} from 'redux';
import {routerReducer} from 'react-router-redux';
import {localeReducer} from 'react-localize-redux';
import {reducer as notificationReducer} from 'react-notification-system-redux';
import auth from '../../modules/auth/reducers';
import role from '../../modules/role/reducers';
import region from '../../modules/region/reducers';
import businessUnit from '../../modules/businessUnit/reducers';
import systemAdmin from '../../modules/users/systemAdmin/reducers';
import executive from '../../modules/users/executive/reducers';
import administration from '../../modules/users/administration/reducers';
import supervisor from '../../modules/users/supervisor/reducers';
import locationCustomer from '../../modules/users/locationCustomer/reducers';
import corpAdmin from '../../modules/users/corpAdmin/reducers';
import teamMember from '../../modules/users/teamMember/reducers';
import workOrder from '../../modules/workOrder/reducers';
import inspection from '../../modules/inspection/reducers';
import report from '../../modules/report/reducers';
import customer from '../../modules/customer/reducers';
import user from '../../modules/user/reducers';
import andon from '../../modules/andon/reducers';
import alertLibrary from '../../modules/alertLibrary/reducers';
import station from '../../modules/station/reducers';
import bin from '../../modules/bin/reducers';
import timeClock from '../../modules/timeClock/reducers';

export default combineReducers({
	router: routerReducer,
	locale: localeReducer,
	notification: notificationReducer,
	...auth,
	...role,
	...region,
	...businessUnit,
	...systemAdmin,
	...executive,
	...administration,
	...supervisor,
	...teamMember,
	...locationCustomer,
	...corpAdmin,
	...workOrder,
	...inspection,
	...report,
	...customer,
	...user,
	...andon,
	...alertLibrary,
	...station,
	...bin,
	...timeClock
})
